export default __webpack_public_path__ + "static/connected-46984b8a7eaaadb28ed29dcf56e2a717.png";